export const ENV_STAGES = {
    localhost: 'local',
    ALPHA: 'alpha-smartbiz-seller.corp.amazon.com',
    BETA: 'beta-smartbiz-seller.corp.amazon.com',
    GAMMA: 'gamma-smartbiz-seller.corp.amazon.com',
    PROD: 'smartbiz.amazon.in',
};